import React, { ReactNode, useState, useRef, useEffect } from 'react';

import Button from '@/ui/Button';
import { TriangleDownIcon, TriangleUpIcon } from '@radix-ui/react-icons';
import Card from '@/ui/Card';

import * as Styled from './styled';

interface ExpandableContainerProps {
  maxHeight?: number;
  expandText?: string;
  collapseText?: string;
  children?: ReactNode;
}

const ExpandableContainer = ({
  maxHeight = 400,
  expandText = 'Show More',
  collapseText = 'Show Less',
  children,
}: ExpandableContainerProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldShowExpand, setShouldShowExpand] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      const contentHeight = contentRef.current.scrollHeight;
      setShouldShowExpand(contentHeight > maxHeight);
    }
  }, [maxHeight, children]);

  return (
    <Card.White gap={10} shadow stretch>
      <Styled.ExpandContainer ref={contentRef} $isExpanded={isExpanded} $maxHeight={maxHeight}>
        {children}
        {!isExpanded && shouldShowExpand && <Styled.ExpandGradient />}
      </Styled.ExpandContainer>
      {shouldShowExpand && (
        <Button.Secondary small onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? collapseText : expandText}
          {isExpanded ? <TriangleUpIcon /> : <TriangleDownIcon />}
        </Button.Secondary>
      )}
    </Card.White>
  );
};

export default ExpandableContainer;
